<template>
    <v-dialog v-model="modal" width="500">
        <conditions
            :disable-currency-conversion="disableCurrencyConversion"
            :offer="offer"
            :offer-key="offerKey"
            :conditions-info-data="conditionsInfoData"
            @close-modal="modal = false"
        />
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'
    import Conditions from '@/components/account/Conditions.vue'
    import {EventBus, HIDE_CONDITIONAL_MODAL_INFO, SHOW_CONDITIONS_MODAL_EVENT} from '@/utils/event-bus'

    @Component({
        components: {Conditions},
    })
    export class ConditionsModal extends Vue {
        @Prop({type: Boolean}) disableCurrencyConversion

        modal = false
        offer = null
        offerKey = null
        conditionsInfoData = {}

        @Watch('modal')
        onModalChange(modal) {
            if (!modal) {
                EventBus.$emit(HIDE_CONDITIONAL_MODAL_INFO)
            }
        }

        mounted() {
            EventBus.$on(SHOW_CONDITIONS_MODAL_EVENT, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_CONDITIONS_MODAL_EVENT, this.showModal)
        }

        showModal({offerKey, conditionsInfo, offer}) {
            this.offerKey = offerKey
            this.conditionsInfoData = conditionsInfo
            this.offer = offer
            this.modal = true
        }
    }

    export default ConditionsModal
</script>
